import type { DefaultOptionType } from 'antd/es/select';
import { default as Tooltip } from 'antd/es/tooltip';
import { useCallback } from 'react';
import { CountryFlag } from 'shared/src/CountryFlag';
import { getCountryCode } from 'shared/src/getCountryCode';

import { useCurrencyLabel } from 'hooks/useCurrencyLabel';

// Utility function to format the label
export const useFormatCurrencyOptionLabel = () => {
  const currencyLabel = useCurrencyLabel();

  const formatCurrencyOptionLabel = useCallback(
    (option: DefaultOptionType) => {
      const codeLabel = currencyLabel.fromCode(option.value?.toString());
      const label = `${option.value} - ${codeLabel}`;

      return {
        index: label,
        label: (
          <Tooltip
            title={label}
            placement="right"
            arrow={false}
            mouseEnterDelay={0.8}
          >
            <div className="flex flex-row items-center gap-2 overflow-hidden">
              <CountryFlag
                className="!size-[22px]"
                countryCode={getCountryCode(option?.value?.toString() ?? '')}
                svg
              />
              {label}
            </div>
          </Tooltip>
        ),
        value: option.value
      };
    },
    [currencyLabel]
  );

  return formatCurrencyOptionLabel;
};
